import { createSlice, current } from '@reduxjs/toolkit'
import {
  createVisit,
  getVehicleVisitingPoints,
  getCarPriceEstimator,
  getEstimatedPriceOfBodyInsurance,
  getVisitItem,
  getLicensePlateInquiry,
  getVisitList,
  uploadVehicleVisitingPointFiles,
  uploadVideoFile,
  uploadNotHealthyAutoPartsFiles,
  uploadDeliberateliesFiles,
  uploadVehicleAccessoriesFiles,
  completePendingVisit,
  getVisitDeliberatelyData,
  getVehicleOptions,
  getUploadLink,
  uploadVehicleVisitingPointFilesPodSpace,
  uploadDeliberateliesFilesPodSpace,
  uploadVideoFilePodSpace,
  uploadNotHealthyAutoPartsFilesPodSpace,
  uploadVehicleAccessoriesFilesPodSpace,
  getAllAutoParts,
  getAllVehicleAccessories,
  getAllVehicleTypes,
  getAllVehicleUsages,
  getAllVehicleBrands,
  getAllVehicleTips,
  getAllVehicleColors,
  getAllStates,
  getAllCities,
  GetAllWithVehicleTypes,
  GetAllPlateSerial,
  getDraftVisitList,
  getDraftVisitItem,
  GetVisitRequestPagedFilter,
  GetVisitRequestById,
  GetAllCountry,
  GetVisitRequestByNotificationId,
} from './action'
import IVisitsState from './model'
import { removeVisit, setVisit } from './TempVisits'

export const initialState: IVisitsState = {
  countries: {
    data: null,
  },
  insuranceUnits: {
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 1,
      customPageSize: 10,
    },
  },
  IInsuranceExpertFieldsState: {
    isOpenSearchAside: false,
    insuranceExpertFieldList: {
      loading: false,
      data: [],
      queryParams: {
        expertId: null,
        insuranceTypeCoreId: null,
        insuranceTypeTitle: '',
        operationType: null,
        coverageLimit: null,
        pageNumber: 1,
      },
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 1,
      customPageSize: 10,
    },
    insuranceExpertField: {
      getByIdLoading: false,
      data: undefined,
    },
  },
  filterModalVisible: false,
  dispatchRequestList: {
    selectedItem: null,
    dispatchId: null,
    loading: false,
    isFetchingNextPage: false,
    loaded: false,
    data: [],
    queryParams: {
      plate: undefined,
      chassisNumber: '',
      engineNumber: '',
      firstName: '',
      lastName: '',
      insuranceTypeId: undefined,
      AssignedVisitRequestStatus: undefined,
      visitStartDate: undefined,
      visitEndDate: undefined,
      pageNumber: 1,
      pageSize: 10,
    },
  },
  visitScrollTop: 0,
  visitList: {
    loading: false,
    isFetchingNextPage: false,
    loaded: false,
    data: [],
    queryParams: {
      plate: undefined,
      chassisNumber: '',
      engineNumber: '',
      firstName: '',
      lastName: '',
      insuranceTypeId: undefined,
      visitStatus: undefined,
      visitStartDate: undefined,
      visitEndDate: undefined,
      pageNumber: 1,
      pageSize: 10,
    },
  },
  draftVisitList: {
    loading: false,
    isFetchingNextPage: false,
    loaded: false,
    data: [],
    queryParams: {
      plate: undefined,
      chassisNumber: '',
      engineNumber: '',
      firstName: '',
      lastName: '',
      insuranceTypeId: undefined,
      draftVisitStatus: undefined,
      visitStartDate: undefined,
      visitEndDate: undefined,
      pageNumber: 1,
      pageSize: 10,
    },
  },
  deliberatelyData: {
    loading: false,
    data: undefined,
  },
  visitItem: {
    loading: false,
    data: undefined,
  },
  draftVisitItem: {
    loading: false,
    data: undefined,
  },
  completePendingVisit: {
    loading: false,
  },
  newVisit: {
    visitLocalId: undefined,
    draftVisitId: undefined,
    isSaved: false,
    hasError: false,
    saveWithoutNet: false,
    storeFileType: 'POD_SPACE',
    visitId: undefined,
    visitStatus: undefined,
    uploadLink: {
      loading: false,
      loaded: false,
      lastLinkGetTime: undefined,
      link: '',
    },
    customerInfo: {
      civilRegistryConfirmationLoaded: false,
      validateLegalCustomerSuccess: false,
      validateLegalCustomerData: undefined,
      personType: 0,
      isDeath: false,
      firstName: '',
      lastName: undefined,
      identityCode: '',
      birthDate: undefined,
      gender: 0,
      mobilePhoneNumber: '',
      visitLocationType: 0,
      stateId: undefined,
      cityId: undefined,
      location: undefined,
      nationalityID: 29,
    },
    customerDeliberately: {
      loading: false,
      nationalCard: undefined,
      nationalCardBack: undefined,
      vehicleDeliberatelyType: 'CARD',
      vehicleCard: undefined,
      vehicleCardBack: undefined,
      vehicleDoc: undefined,
      vehicleCompanyDoc: undefined,
    },
    carInfo: {
      plate: undefined,
      vehicleTypeId: undefined,
      hasTrailer: undefined,
      vehicleBrandId: undefined,
      vehicleTipId: undefined,
      vehicleColorId: undefined,
      vehicleUsageId: undefined,
      vehicleStatus: undefined,
      numberOfCylinders: undefined,
      yearOfConstruction: undefined,
      vehicleMileage: undefined,
      chassisNumber: '',
      engineNumber: '',
      VIN: '',
    },
    vehicleVisitingPoints: {
      data: [],
      currentImage: 0,
      mode: 'Image',
      loading: false,
      recordedChunks: [],
      videoRecorded: false,
      videoLoading: false,
      videoUploadProgress: 0,
      videoFileId: undefined,
      videoStatus: 0,
      videoCancelToken: '',
      skipVideo: false,
    },
    notHealthyAutoParts: {
      data: [],
      loading: false,
    },
    vehicleAccessories: {
      data: [],
      loading: false,
    },
    prices: {
      loading: false,
      loaded: false,
      price: undefined,
      towingValue: undefined,
      totalValue: undefined,
    },
    vehicleOptions: [],
    coverages: {
      mainBodyInsuranceCoverageId: undefined,
      additionalBodyInsuranceCoverageId: [],
      loading: false,
      loaded: false,
      estimatedPriceOfBodyInsurance: undefined,
    },
    createVisitErrorLog: {
      loading: false
    },
    description: '',
    loading: false,
  },
  vehicleVisitingPoints: {
    vehicleVisitingPointsLoading: false,
    vehicleVisitingPointsLoaded: undefined,
    data: [],
  },
  vehicleOptionList: {
    vehicleOptionsLoading: false,
    vehicleOptionsLoaded: undefined,
    data: [],
  },
  autoParts: {
    autoPartsLoading: false,
    autoPartsLoaded: undefined,
    data: [],
  },
  vehicleAccessories: {
    vehicleAccessoriesLoading: false,
    vehicleAccessoriesLoaded: undefined,
    data: [],
  },
  vehicleTypes: {
    vehicleTypesLoading: false,
    vehicleTypesLoaded: undefined,
    data: [],
  },
  vehicleUsages: {
    vehicleUsagesLoading: false,
    vehicleUsagesLoaded: undefined,
    data: [],
  },
  vehicleBrands: {
    vehicleBrandsLoading: false,
    vehicleBrandsLoaded: undefined,
    data: [],
  },
  vehicleTips: {
    vehicleTipsLoading: false,
    vehicleTipsLoaded: undefined,
    data: [],
  },
  vehicleColors: {
    vehicleColorsLoading: false,
    vehicleColorsLoaded: undefined,
    data: [],
  },
  states: {
    statesLoading: false,
    statesLoaded: undefined,
    data: [],
  },
  cities: {
    citiesLoading: false,
    citiesLoaded: undefined,
    data: [],
  },
  cargoRoom: {
    cargoroomLoading: false,
    cargoRoomLoaded: undefined,
    data: [],
  },
  freeZone: {
    freeZoneLoading: false,
    freeZoneLoaded: undefined,
    data: [],
  },
  CountryList: {
    lCountrysLoading: false,
    lCountrysLoaded: undefined,
    data: [],
  },
}

export const visitsReducer = createSlice({
  name: 'Visits',
  initialState,
  reducers: {
    setFilterModalVisible: (state, action) => {
      state.filterModalVisible = action.payload
    },

    clearVisitList: state => {
      state.visitList.data = []
      state.visitList.queryParams.pageNumber = 1
      state.visitList.loaded = false
    },

    setFilters: (state, action) => {
      state.visitList.queryParams = action.payload
      state.draftVisitList.queryParams = action.payload
      state.dispatchRequestList.queryParams = action.payload
      state.visitList.loaded = false
      state.draftVisitList.loaded = false
      state.dispatchRequestList.loaded = false
      state.filterModalVisible = false
    },

    setVisitListParams: (state, action) => {
      state.visitList.queryParams = action.payload
    },

    setDraftVisitId: (state, action) => {
      state.newVisit.draftVisitId = action.payload
    },

    setDispatchId: (state, action) => {
      state.dispatchRequestList.dispatchId = action.payload
    },
    setCustomerInfo: (state, action) => {
      state.newVisit.customerInfo = action.payload
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    setCivilRegistryConfirmationLoaded: (state, action) => {
      state.newVisit.customerInfo.civilRegistryConfirmationLoaded = action.payload
    },
    setValidateLegalCustomerSuccess: (state, action) => {
      state.newVisit.customerInfo.validateLegalCustomerSuccess = action.payload
    },
    setValidateLegalCustomerData: (state, action) => {
      state.newVisit.customerInfo.validateLegalCustomerData = action.payload
    },

    setCivilRegistryConfirmationIsDeath: (state, action) => {
      state.newVisit.customerInfo.isDeath = action.payload
    },

    setCustomerDeliberately: (state, action) => {
      if (action.payload.id == 1) state.newVisit.customerDeliberately.nationalCard = action.payload
      else if (action.payload.id == 2)
        state.newVisit.customerDeliberately.nationalCardBack = action.payload
      else if (action.payload.id == 3)
        state.newVisit.customerDeliberately.vehicleCard = action.payload
      else if (action.payload.id == 4)
        state.newVisit.customerDeliberately.vehicleCardBack = action.payload
      else if (action.payload.id == 5)
        state.newVisit.customerDeliberately.vehicleDoc = action.payload
      else if (action.payload.id == 6)
        state.newVisit.customerDeliberately.vehicleCompanyDoc = action.payload
    },
    removeCustomerDeliberately: (state, action) => {
      if (action.payload == 1) state.newVisit.customerDeliberately.nationalCard = undefined
      else if (action.payload == 2) state.newVisit.customerDeliberately.nationalCardBack = undefined
      else if (action.payload == 3) state.newVisit.customerDeliberately.vehicleCard = undefined
      else if (action.payload == 4) state.newVisit.customerDeliberately.vehicleCardBack = undefined
      else if (action.payload == 5) state.newVisit.customerDeliberately.vehicleDoc = undefined
      else if (action.payload == 6)
        state.newVisit.customerDeliberately.vehicleCompanyDoc = undefined
    },
    setCustomerVehicleDeliberatelyType: (state, action) => {
      state.newVisit.customerDeliberately.vehicleDeliberatelyType = action.payload
    },

    setDeliberatelyFileContent: (state, action) => {
      if (
        state.newVisit.customerDeliberately.nationalCard &&
        action.payload.id == state.newVisit.customerDeliberately.nationalCard.id
      )
        state.newVisit.customerDeliberately.nationalCard.image = action.payload.image
      else if (
        state.newVisit.customerDeliberately.nationalCardBack &&
        action.payload.id == state.newVisit.customerDeliberately.nationalCardBack.id
      )
        state.newVisit.customerDeliberately.nationalCardBack.image = action.payload.image
      else if (
        state.newVisit.customerDeliberately.vehicleCard &&
        action.payload.id == state.newVisit.customerDeliberately.vehicleCard.id
      )
        state.newVisit.customerDeliberately.vehicleCard.image = action.payload.image
      else if (
        state.newVisit.customerDeliberately.vehicleCardBack &&
        action.payload.id == state.newVisit.customerDeliberately.vehicleCardBack.id
      )
        state.newVisit.customerDeliberately.vehicleCardBack.image = action.payload.image
      else if (
        state.newVisit.customerDeliberately.vehicleDoc &&
        action.payload.id == state.newVisit.customerDeliberately.vehicleDoc.id
      )
        state.newVisit.customerDeliberately.vehicleDoc.image = action.payload.image
      else if (
        state.newVisit.customerDeliberately.vehicleCompanyDoc &&
        action.payload.id == state.newVisit.customerDeliberately.vehicleCompanyDoc.id
      )
        state.newVisit.customerDeliberately.vehicleCompanyDoc.image = action.payload.image
    },
    setDeliberatelyUploadProgress: (state, action) => {
      if (action.payload.id == 1 && state.newVisit.customerDeliberately.nationalCard)
        state.newVisit.customerDeliberately.nationalCard.uploadProgress = action.payload.progress
      else if (action.payload.id == 2 && state.newVisit.customerDeliberately.nationalCardBack)
        state.newVisit.customerDeliberately.nationalCardBack.uploadProgress =
          action.payload.progress
      else if (action.payload.id == 3 && state.newVisit.customerDeliberately.vehicleCard)
        state.newVisit.customerDeliberately.vehicleCard.uploadProgress = action.payload.progress
      else if (action.payload.id == 4 && state.newVisit.customerDeliberately.vehicleCardBack)
        state.newVisit.customerDeliberately.vehicleCardBack.uploadProgress = action.payload.progress
      else if (action.payload.id == 5 && state.newVisit.customerDeliberately.vehicleDoc)
        state.newVisit.customerDeliberately.vehicleDoc.uploadProgress = action.payload.progress
      else if (action.payload.id == 6 && state.newVisit.customerDeliberately.vehicleCompanyDoc)
        state.newVisit.customerDeliberately.vehicleCompanyDoc.uploadProgress =
          action.payload.progress
    },
    successDeliberatelyUploadFile: (state, action) => {
      if (action.payload.id == 1 && state.newVisit.customerDeliberately.nationalCard) {
        state.newVisit.customerDeliberately.nationalCard.status = 1
        if (state.newVisit.storeFileType == 'POD_SPACE') {
          state.newVisit.customerDeliberately.nationalCard.hashFile = action.payload.hashFile
          state.newVisit.customerDeliberately.nationalCard.hashFileType =
            action.payload.hashFileType
          state.newVisit.customerDeliberately.nationalCard.hashFileExtension =
            action.payload.hashFileExtension
          state.newVisit.customerDeliberately.nationalCard.hashFileSize =
            action.payload.hashFileSize
        } else {
          state.newVisit.customerDeliberately.nationalCard.fileId = action.payload.fileId
        }
      } else if (action.payload.id == 2 && state.newVisit.customerDeliberately.nationalCardBack) {
        state.newVisit.customerDeliberately.nationalCardBack.status = 1
        if (state.newVisit.storeFileType == 'POD_SPACE') {
          state.newVisit.customerDeliberately.nationalCardBack.hashFile = action.payload.hashFile
          state.newVisit.customerDeliberately.nationalCardBack.hashFileType =
            action.payload.hashFileType
          state.newVisit.customerDeliberately.nationalCardBack.hashFileExtension =
            action.payload.hashFileExtension
          state.newVisit.customerDeliberately.nationalCardBack.hashFileSize =
            action.payload.hashFileSize
        } else {
          state.newVisit.customerDeliberately.nationalCardBack.fileId = action.payload.fileId
        }
      } else if (action.payload.id == 3 && state.newVisit.customerDeliberately.vehicleCard) {
        state.newVisit.customerDeliberately.vehicleCard.status = 1
        if (state.newVisit.storeFileType == 'POD_SPACE') {
          state.newVisit.customerDeliberately.vehicleCard.hashFile = action.payload.hashFile
          state.newVisit.customerDeliberately.vehicleCard.hashFileType = action.payload.hashFileType
          state.newVisit.customerDeliberately.vehicleCard.hashFileExtension =
            action.payload.hashFileExtension
          state.newVisit.customerDeliberately.vehicleCard.hashFileSize = action.payload.hashFileSize
        } else {
          state.newVisit.customerDeliberately.vehicleCard.fileId = action.payload.fileId
        }
      } else if (action.payload.id == 4 && state.newVisit.customerDeliberately.vehicleCardBack) {
        state.newVisit.customerDeliberately.vehicleCardBack.status = 1
        if (state.newVisit.storeFileType == 'POD_SPACE') {
          state.newVisit.customerDeliberately.vehicleCardBack.hashFile = action.payload.hashFile
          state.newVisit.customerDeliberately.vehicleCardBack.hashFileType =
            action.payload.hashFileType
          state.newVisit.customerDeliberately.vehicleCardBack.hashFileExtension =
            action.payload.hashFileExtension
          state.newVisit.customerDeliberately.vehicleCardBack.hashFileSize =
            action.payload.hashFileSize
        } else {
          state.newVisit.customerDeliberately.vehicleCardBack.fileId = action.payload.fileId
        }
      } else if (action.payload.id == 5 && state.newVisit.customerDeliberately.vehicleDoc) {
        state.newVisit.customerDeliberately.vehicleDoc.status = 1
        if (state.newVisit.storeFileType == 'POD_SPACE') {
          state.newVisit.customerDeliberately.vehicleDoc.hashFile = action.payload.hashFile
          state.newVisit.customerDeliberately.vehicleDoc.hashFileType = action.payload.hashFileType
          state.newVisit.customerDeliberately.vehicleDoc.hashFileExtension =
            action.payload.hashFileExtension
          state.newVisit.customerDeliberately.vehicleDoc.hashFileSize = action.payload.hashFileSize
        } else {
          state.newVisit.customerDeliberately.vehicleDoc.fileId = action.payload.fileId
        }
      } else if (action.payload.id == 6 && state.newVisit.customerDeliberately.vehicleCompanyDoc) {
        state.newVisit.customerDeliberately.vehicleCompanyDoc.status = 1
        if (state.newVisit.storeFileType == 'POD_SPACE') {
          state.newVisit.customerDeliberately.vehicleCompanyDoc.hashFile = action.payload.hashFile
          state.newVisit.customerDeliberately.vehicleCompanyDoc.hashFileType =
            action.payload.hashFileType
          state.newVisit.customerDeliberately.vehicleCompanyDoc.hashFileExtension =
            action.payload.hashFileExtension
          state.newVisit.customerDeliberately.vehicleCompanyDoc.hashFileSize =
            action.payload.hashFileSize
        } else {
          state.newVisit.customerDeliberately.vehicleCompanyDoc.fileId = action.payload.fileId
        }
      }
    },
    failureDeliberatelyUploadFile: (state, action) => {
      if (action.payload == 1 && state.newVisit.customerDeliberately.nationalCard) {
        state.newVisit.customerDeliberately.nationalCard.uploadProgress = 0
        state.newVisit.customerDeliberately.nationalCard.status = 2
      } else if (action.payload == 2 && state.newVisit.customerDeliberately.nationalCardBack) {
        state.newVisit.customerDeliberately.nationalCardBack.uploadProgress = 0
        state.newVisit.customerDeliberately.nationalCardBack.status = 2
      } else if (action.payload == 3 && state.newVisit.customerDeliberately.vehicleCard) {
        state.newVisit.customerDeliberately.vehicleCard.uploadProgress = 0
        state.newVisit.customerDeliberately.vehicleCard.status = 2
      } else if (action.payload == 4 && state.newVisit.customerDeliberately.vehicleCardBack) {
        state.newVisit.customerDeliberately.vehicleCardBack.uploadProgress = 0
        state.newVisit.customerDeliberately.vehicleCardBack.status = 2
      } else if (action.payload == 5 && state.newVisit.customerDeliberately.vehicleDoc) {
        state.newVisit.customerDeliberately.vehicleDoc.uploadProgress = 0
        state.newVisit.customerDeliberately.vehicleDoc.status = 2
      } else if (action.payload == 6 && state.newVisit.customerDeliberately.vehicleCompanyDoc) {
        state.newVisit.customerDeliberately.vehicleCompanyDoc.uploadProgress = 0
        state.newVisit.customerDeliberately.vehicleCompanyDoc.status = 2
      }
    },
    setDeliberatelyCancelToken: (state, action) => {
      if (action.payload.id == 1 && state.newVisit.customerDeliberately.nationalCard)
        state.newVisit.customerDeliberately.nationalCard.cancelToken = action.payload.cancelToken
      else if (action.payload.id == 2 && state.newVisit.customerDeliberately.nationalCardBack)
        state.newVisit.customerDeliberately.nationalCardBack.cancelToken =
          action.payload.cancelToken
      else if (action.payload.id == 3 && state.newVisit.customerDeliberately.vehicleCard)
        state.newVisit.customerDeliberately.vehicleCard.cancelToken = action.payload.cancelToken
      else if (action.payload.id == 4 && state.newVisit.customerDeliberately.vehicleCardBack)
        state.newVisit.customerDeliberately.vehicleCardBack.cancelToken = action.payload.cancelToken
      else if (action.payload.id == 5 && state.newVisit.customerDeliberately.vehicleDoc)
        state.newVisit.customerDeliberately.vehicleDoc.cancelToken = action.payload.cancelToken
      else if (action.payload.id == 6 && state.newVisit.customerDeliberately.vehicleCompanyDoc)
        state.newVisit.customerDeliberately.vehicleCompanyDoc.cancelToken =
          action.payload.cancelToken
    },

    setCarInfo: (state, action) => {
      state.newVisit.carInfo = action.payload
      state.newVisit.prices.loaded = false
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    setVehicleOptions: (state, action) => {
      var index = state.newVisit.vehicleOptions.findIndex(
        x => x.vehicleOptionId == action.payload.vehicleOptionId,
      )
      if (index > -1) state.newVisit.vehicleOptions.splice(index, 1)
      state.newVisit.vehicleOptions.push(action.payload)
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    setPrice: (state, action) => {
      state.newVisit.prices.price = action.payload.price
      state.newVisit.prices.towingValue = action.payload.towingValue
      state.newVisit.prices.totalValue = action.payload.totalValue
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    setCoverages: (state, action) => {
      state.newVisit.coverages.mainBodyInsuranceCoverageId =
        action.payload.mainBodyInsuranceCoverageId
      state.newVisit.coverages.additionalBodyInsuranceCoverageId =
        action.payload.additionalBodyInsuranceCoverageId
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    setDescription: (state, action) => {
      state.newVisit.description = action.payload
      state.newVisit.saveWithoutNet = action.payload.saveWithoutNet
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    setSaveWithoutNet: (state, action) => {
      state.newVisit.saveWithoutNet = action.payload
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    addVehicleVisitingPoint: (state, action) => {
      state.newVisit.vehicleVisitingPoints.data.push(action.payload)
    },
    removeVehicleVisitingPoint: (state, action) => {
      state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.filter(
        x => x.id != action.payload,
      )
    },
    setCurrentImage: (state, action) => {
      state.newVisit.vehicleVisitingPoints.currentImage = action.payload
    },
    setMode: (state, action) => {
      state.newVisit.vehicleVisitingPoints.mode = action.payload
    },
    addRecordedChunk: (state, action) => {
      state.newVisit.vehicleVisitingPoints.recordedChunks.push(action.payload)
    },
    clearVehicleVisitingPoints: state => {
      state.newVisit.vehicleVisitingPoints.data = []
      state.newVisit.vehicleVisitingPoints.currentImage = 0
      state.newVisit.vehicleVisitingPoints.mode = 'Image'
    },
    clearVehicleVisitingPointsAndVideo: state => {
      state.newVisit.vehicleVisitingPoints = {
        data: [],
        currentImage: 0,
        mode: 'Image',
        loading: false,
        recordedChunks: [],
        videoRecorded: false,
        videoLoading: false,
        videoUploadProgress: 0,
        videoFileId: undefined,
        videoHashFile: undefined,
        videoHashFileType: undefined,
        videoHashFileExtension: undefined,
        videoHashFileSize: undefined,
        videoStatus: 0,
        videoCancelToken: '',
        skipVideo: false,
      }
    },
    clearVideo: state => {
      state.newVisit.vehicleVisitingPoints.recordedChunks = []
      state.newVisit.vehicleVisitingPoints.videoRecorded = false
      state.newVisit.vehicleVisitingPoints.videoLoading = false
      state.newVisit.vehicleVisitingPoints.videoUploadProgress = 0
      state.newVisit.vehicleVisitingPoints.videoFileId = undefined
      state.newVisit.vehicleVisitingPoints.videoHashFile = undefined
      state.newVisit.vehicleVisitingPoints.videoHashFileType = undefined
      state.newVisit.vehicleVisitingPoints.videoHashFileExtension = undefined
      state.newVisit.vehicleVisitingPoints.videoHashFileSize = undefined
      state.newVisit.vehicleVisitingPoints.videoStatus = 0
      state.newVisit.vehicleVisitingPoints.videoCancelToken = ''
      state.newVisit.vehicleVisitingPoints.skipVideo = false
    },
    setVideoRecorded: (state, action) => {
      state.newVisit.vehicleVisitingPoints.videoRecorded = action.payload
    },
    addNotHealthyAutoPart: (state, action) => {
      state.newVisit.notHealthyAutoParts.data.push(action.payload)
    },
    removeNotHealthyAutoPart: (state, action) => {
      state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.filter(
        x => x.id != action.payload,
      )
    },
    addVehicleAccessory: (state, action) => {
      state.newVisit.vehicleAccessories.data.push(action.payload)
    },
    removeVehicleAccessory: (state, action) => {
      state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.filter(
        x => x.id != action.payload,
      )
    },

    setVehicleVisitingPointFileContent: (state, action) => {
      state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.map(
        (file: any) =>
          file.id === action.payload.id ? { ...file, image: action.payload.image } : file,
      )
    },
    setVehicleVisitingPointUploadProgress: (state, action) => {
      state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.map(
        (file: any) =>
          file.id === action.payload.id
            ? { ...file, uploadProgress: action.payload.progress }
            : file,
      )
    },
    successVehicleVisitingPointUploadFile: (state, action) => {
      if (state.newVisit.storeFileType == 'POD_SPACE') {
        state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.map(
          (file: any) =>
            file.id === action.payload.id
              ? {
                ...file,
                status: 1,
                hashFile: action.payload.hashFile,
                hashFileType: action.payload.hashFileType,
                hashFileExtension: action.payload.hashFileExtension,
                hashFileSize: action.payload.hashFileSize,
              }
              : file,
        )
      } else {
        state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.map(
          (file: any) =>
            file.id === action.payload.id
              ? { ...file, status: 1, fileId: action.payload.fileId }
              : file,
        )
      }
    },
    failureVehicleVisitingPointUploadFile: (state, action) => {
      state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.map(
        (file: any) =>
          file.id === action.payload ? { ...file, uploadProgress: 0, status: 2 } : file,
      )
    },
    setVehicleVisitingPointCancelToken: (state, action) => {
      state.newVisit.vehicleVisitingPoints.data = state.newVisit.vehicleVisitingPoints.data.map(
        (file: any) =>
          file.id === action.payload.id
            ? { ...file, cancelToken: action.payload.cancelToken }
            : file,
      )
    },

    setVideoUploadProgress: (state, action) => {
      state.newVisit.vehicleVisitingPoints.videoUploadProgress = action.payload
    },
    successVideoUploadFile: (state, action) => {
      state.newVisit.vehicleVisitingPoints.videoStatus = 1
      if (state.newVisit.storeFileType == 'POD_SPACE') {
        state.newVisit.vehicleVisitingPoints.videoHashFile = action.payload.hashFile
        state.newVisit.vehicleVisitingPoints.videoHashFileType = action.payload.hashFileType
        state.newVisit.vehicleVisitingPoints.videoHashFileExtension =
          action.payload.hashFileExtension
        state.newVisit.vehicleVisitingPoints.videoHashFileSize = action.payload.hashFileSize
      } else {
        state.newVisit.vehicleVisitingPoints.videoFileId = action.payload
      }
    },
    failureVideoUploadFile: state => {
      state.newVisit.vehicleVisitingPoints.videoStatus = 2
      state.newVisit.vehicleVisitingPoints.videoUploadProgress = 0
    },
    setVideoCancelToken: (state, action) => {
      state.newVisit.vehicleVisitingPoints.videoCancelToken = action.payload
    },

    setNotHealthyAutoPartFileContent: (state, action) => {
      state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.map(
        (file: any) =>
          file.id === action.payload.id ? { ...file, image: action.payload.image } : file,
      )
    },
    setNotHealthyAutoPartUploadProgress: (state, action) => {
      state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.map(
        (file: any) =>
          file.id === action.payload.id
            ? { ...file, uploadProgress: action.payload.progress }
            : file,
      )
    },
    successNotHealthyAutoPartUploadFile: (state, action) => {
      if (state.newVisit.storeFileType == 'POD_SPACE') {
        state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.map(
          (file: any) =>
            file.id === action.payload.id
              ? {
                ...file,
                status: 1,
                hashFile: action.payload.hashFile,
                hashFileType: action.payload.hashFileType,
                hashFileExtension: action.payload.hashFileExtension,
                hashFileSize: action.payload.hashFileSize,
              }
              : file,
        )
      } else {
        state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.map(
          (file: any) =>
            file.id === action.payload.id
              ? { ...file, status: 1, fileId: action.payload.fileId }
              : file,
        )
      }
    },
    failureNotHealthyAutoPartUploadFile: (state, action) => {
      state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.map(
        (file: any) =>
          file.id === action.payload ? { ...file, uploadProgress: 0, status: 2 } : file,
      )
    },
    setNotHealthyAutoPartCancelToken: (state, action) => {
      state.newVisit.notHealthyAutoParts.data = state.newVisit.notHealthyAutoParts.data.map(
        (file: any) =>
          file.id === action.payload.id
            ? { ...file, cancelToken: action.payload.cancelToken }
            : file,
      )
    },

    setVehicleAccessoryFileContent: (state, action) => {
      state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.map(
        (file: any) =>
          file.id === action.payload.id ? { ...file, image: action.payload.image } : file,
      )
    },
    setVehicleAccessoryUploadProgress: (state, action) => {
      state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.map(
        (file: any) =>
          file.id === action.payload.id
            ? { ...file, uploadProgress: action.payload.progress }
            : file,
      )
    },
    successVehicleAccessoryUploadFile: (state, action) => {
      if (state.newVisit.storeFileType == 'POD_SPACE') {
        state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.map(
          (file: any) =>
            file.id === action.payload.id
              ? {
                ...file,
                status: 1,
                hashFile: action.payload.hashFile,
                hashFileType: action.payload.hashFileType,
                hashFileExtension: action.payload.hashFileExtension,
                hashFileSize: action.payload.hashFileSize,
              }
              : file,
        )
      } else {
        state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.map(
          (file: any) =>
            file.id === action.payload.id
              ? { ...file, status: 1, fileId: action.payload.fileId }
              : file,
        )
      }
    },
    failureVehicleAccessoryUploadFile: (state, action) => {
      state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.map(
        (file: any) =>
          file.id === action.payload ? { ...file, uploadProgress: 0, status: 2 } : file,
      )
    },
    setVehicleAccessoryCancelToken: (state, action) => {
      state.newVisit.vehicleAccessories.data = state.newVisit.vehicleAccessories.data.map(
        (file: any) =>
          file.id === action.payload.id
            ? { ...file, cancelToken: action.payload.cancelToken }
            : file,
      )
    },

    setSkipVideo: (state, action) => {
      state.newVisit.vehicleVisitingPoints.skipVideo = action.payload
      const visitCopy = current(state.newVisit)
      setVisit({ ...visitCopy })
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },

    clearNewVisit: (state, action) => {
      state.newVisit.visitLocalId = Math.random()
      state.newVisit.draftVisitId = undefined
      state.newVisit.createTime = new Date()
      state.newVisit.lastChangeTime = undefined
      state.newVisit.isSaved = false
      state.newVisit.hasError = false
      state.newVisit.saveWithoutNet = false
      state.newVisit.storeFileType = action.payload

      state.newVisit.visitId = undefined
      state.newVisit.visitStatus = undefined

      state.newVisit.uploadLink = {
        loading: false,
        loaded: false,
        lastLinkGetTime: undefined,
        link: '',
      }

      state.newVisit.customerInfo = {
        civilRegistryConfirmationLoaded: false,
        validateLegalCustomerSuccess: false,
        validateLegalCustomerData: undefined,
        personType: 0,
        isDeath: false,
        firstName: '',
        lastName: undefined,
        identityCode: '',
        birthDate: undefined,
        gender: 0,
        mobilePhoneNumber: '',
        visitLocationType: 0,
        stateId: undefined,
        cityId: undefined,
        location: undefined,
        nationalityID: 29,
      }
      state.newVisit.customerDeliberately = {
        loading: false,
        nationalCard: undefined,
        nationalCardBack: undefined,
        vehicleDeliberatelyType: 'CARD',
        vehicleCard: undefined,
        vehicleCardBack: undefined,
        vehicleDoc: undefined,
        vehicleCompanyDoc: undefined,
      }
      state.newVisit.carInfo = {
        plate: undefined,
        vehicleTypeId: undefined,
        vehicleBrandId: undefined,
        vehicleTipId: undefined,
        cargoCompartmentId: undefined,
        vehicleColorId: undefined,
        vehicleUsageId: undefined,
        vehicleStatus: undefined,
        numberOfCylinders: undefined,
        yearOfConstruction: undefined,
        vehicleMileage: undefined,
        chassisNumber: '',
        engineNumber: '',
        VIN: '',
      }
      state.newVisit.vehicleVisitingPoints = {
        data: [],
        currentImage: 0,
        mode: 'Image',
        loading: false,
        recordedChunks: [],
        videoRecorded: false,
        videoLoading: false,
        videoUploadProgress: 0,
        videoFileId: undefined,
        videoHashFile: undefined,
        videoHashFileType: undefined,
        videoHashFileExtension: undefined,
        videoHashFileSize: undefined,
        videoStatus: 0,
        videoCancelToken: '',
        skipVideo: false,
      }
      state.newVisit.notHealthyAutoParts = {
        data: [],
        loading: false,
      }
      state.newVisit.vehicleAccessories = {
        data: [],
        loading: false,
      }
      state.newVisit.vehicleOptions = []
      state.newVisit.prices = {
        loading: false,
        loaded: false,
        price: undefined,
        towingValue: undefined,
      }
      state.newVisit.coverages = {
        mainBodyInsuranceCoverageId: undefined,
        additionalBodyInsuranceCoverageId: [],
        loading: false,
        loaded: false,
        estimatedPriceOfBodyInsurance: undefined,
      }
      state.newVisit.description = ''
    },
    setNewVisit: (state, action) => {
      state.newVisit = action.payload
    },
    setStoreFileType: (state, action) => {
      state.newVisit.storeFileType = action.payload
      if (!state.newVisit.visitLocalId) {
        state.newVisit.visitLocalId = Math.random()
        state.newVisit.createTime = new Date()
      }
    },
    saveVisit: state => {
      const visitCopy = current(state.newVisit)
      const requiredCount = state.vehicleVisitingPoints.data?.filter(x => x.isRequird)?.length ?? 0
      setVisit(
        { ...visitCopy },
        state.newVisit.vehicleVisitingPoints.data.length > 0 &&
        state.newVisit.vehicleVisitingPoints.data.length < requiredCount,
      )
      state.newVisit.lastChangeTime = new Date()
      state.newVisit.isSaved = true
    },
    setVisitScrollTop: (state, action) => {
      state.visitScrollTop = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getVisitList.pending, state => {
        if (state.visitList.queryParams.pageNumber > 1) {
          state.visitList.isFetchingNextPage = true
        } else {
          state.visitList.loading = true
        }
      })
      .addCase(getVisitList.fulfilled, (state, action) => {
        state.visitList.loading = false
        state.visitList.isFetchingNextPage = false

        if (state.visitList.queryParams.pageNumber === 1) {
          state.visitList.data = action.payload?.queryResult
        } else if (action.payload?.queryResult?.length) {
          state.visitList.data = [...state.visitList.data, ...action.payload.queryResult]
        }

        state.visitList.queryParams.pageNumber++

        if (state.visitList.data?.length === action.payload?.totalCount) {
          state.visitList.loaded = true
        }
      })
      .addCase(getVisitList.rejected, state => {
        state.visitList.loading = false
        state.visitList.isFetchingNextPage = false
      })

    builder
      .addCase(getDraftVisitList.pending, state => {
        if (state.draftVisitList.queryParams.pageNumber > 1) {
          state.draftVisitList.isFetchingNextPage = true
        } else {
          state.draftVisitList.loading = true
        }
      })
      .addCase(getDraftVisitList.fulfilled, (state, action) => {
        state.draftVisitList.loading = false
        state.draftVisitList.isFetchingNextPage = false

        if (state.draftVisitList.queryParams.pageNumber === 1) {
          state.draftVisitList.data = action.payload?.queryResult
        } else if (action.payload?.queryResult?.length) {
          state.draftVisitList.data = [...state.draftVisitList.data, ...action.payload.queryResult]
        }

        state.draftVisitList.queryParams.pageNumber++

        if (state.draftVisitList.data?.length === action.payload?.totalCount) {
          state.draftVisitList.loaded = true
        }
      })
      .addCase(getDraftVisitList.rejected, state => {
        state.draftVisitList.loading = false
        state.draftVisitList.isFetchingNextPage = false
      })

    builder
      .addCase(GetVisitRequestPagedFilter.pending, state => {
        if (state.dispatchRequestList.queryParams.pageNumber > 1) {
          state.dispatchRequestList.isFetchingNextPage = true
        } else {
          state.dispatchRequestList.loading = true
        }
      })

      // .addCase(GetVisitRequestPagedFilter.fulfilled, (state, action) => {
      //   state.dispatchRequestList.loading = false
      //   state.dispatchRequestList.isFetchingNextPage = false

      //   const result = action.payload?.queryResult ?? []

      //   if (state.dispatchRequestList.queryParams.PageNumber === 1) {
      //     state.dispatchRequestList.data = result
      //   } else {
      //     state.dispatchRequestList.data.push(...result)
      //   }

      //   state.dispatchRequestList.queryParams.PageNumber++

      //   if (state.dispatchRequestList.data.length >= action.payload?.totalCount) {
      //     state.dispatchRequestList.loaded = true
      //   }
      // })

      .addCase(GetVisitRequestPagedFilter.fulfilled, (state, action) => {
        state.dispatchRequestList.loading = false
        state.dispatchRequestList.isFetchingNextPage = false

        if (state.dispatchRequestList.queryParams.pageNumber === 1) {
          state.dispatchRequestList.data = action.payload?.queryResult
        } else if (action.payload?.queryResult?.length) {
          state.dispatchRequestList.data = [
            ...state.dispatchRequestList.data,
            ...action.payload.queryResult,
          ]
        }

        state.dispatchRequestList.queryParams.pageNumber++

        if (state.dispatchRequestList.data?.length === action.payload?.totalCount) {
          state.dispatchRequestList.loaded = true
        }
      })
      .addCase(GetVisitRequestPagedFilter.rejected, state => {
        state.dispatchRequestList.loading = false
        state.dispatchRequestList.isFetchingNextPage = false
      })

    builder
      .addCase(GetVisitRequestById.pending, state => {
        state.dispatchRequestList.loading = true
      })
      .addCase(GetVisitRequestById.fulfilled, (state, action) => {
        state.dispatchRequestList.loading = false
        state.dispatchRequestList.selectedItem = action.payload
      })

      .addCase(GetVisitRequestById.rejected, state => {
        state.dispatchRequestList.loading = false
      })

    builder
      .addCase(GetVisitRequestByNotificationId.pending, state => {
        state.dispatchRequestList.loading = true
      })
      .addCase(GetVisitRequestByNotificationId.fulfilled, (state, action) => {
        state.dispatchRequestList.loading = false
        state.dispatchRequestList.selectedItem = action.payload
      })

      .addCase(GetVisitRequestByNotificationId.rejected, state => {
        state.dispatchRequestList.loading = false
      })

    builder
      .addCase(GetAllCountry.pending, state => {
        state.CountryList.lCountrysLoading = true
        state.CountryList.lCountrysLoaded = false
      })
      .addCase(GetAllCountry.fulfilled, (state, action) => {
        state.CountryList.lCountrysLoading = false
        if (action.payload && action.payload.length) {
          state.CountryList.lCountrysLoaded = true
          state.CountryList.data = action.payload
        } else {
          state.CountryList.lCountrysLoaded = false
        }
      })
      .addCase(GetAllCountry.rejected, state => {
        state.CountryList.lCountrysLoading = false
      })

    builder
      .addCase(getVisitItem.pending, state => {
        state.visitItem.loading = true
      })
      .addCase(getVisitItem.fulfilled, (state, action) => {
        state.visitItem.loading = false
        state.visitItem.data = action.payload
      })
      .addCase(getVisitItem.rejected, state => {
        state.visitItem.loading = false
      })

    builder
      .addCase(getDraftVisitItem.pending, state => {
        state.draftVisitItem.loading = true
      })
      .addCase(getDraftVisitItem.fulfilled, (state, action) => {
        state.draftVisitItem.loading = false
        state.draftVisitItem.data = action.payload
      })
      .addCase(getDraftVisitItem.rejected, state => {
        state.draftVisitItem.loading = false
      })

    builder
      .addCase(getVisitDeliberatelyData.pending, state => {
        state.deliberatelyData.loading = true
      })
      .addCase(getVisitDeliberatelyData.fulfilled, (state, action) => {
        state.deliberatelyData.loading = false
        state.deliberatelyData.data = action.payload
      })
      .addCase(getVisitDeliberatelyData.rejected, state => {
        state.deliberatelyData.loading = false
      })

    builder
      .addCase(getVehicleVisitingPoints.pending, state => {
        state.vehicleVisitingPoints.vehicleVisitingPointsLoading = true
        state.vehicleVisitingPoints.vehicleVisitingPointsLoaded = false
      })
      .addCase(getVehicleVisitingPoints.fulfilled, (state, action) => {
        state.vehicleVisitingPoints.vehicleVisitingPointsLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleVisitingPoints.vehicleVisitingPointsLoaded = true
          state.vehicleVisitingPoints.data = action.payload?.map((x: any) => {
            return {
              value: x.id,
              label: x.title,
              isRequird: x.isRequird,
              imageCaptureTimeSec: x.imageCaptureTimeSec,
              isPlatePhotoAvailable: x.isPlatePhotoAvailable,
            }
          })
        } else {
          state.vehicleVisitingPoints.vehicleVisitingPointsLoaded = false
        }
      })
      .addCase(getVehicleVisitingPoints.rejected, state => {
        state.vehicleVisitingPoints.vehicleVisitingPointsLoading = false
      })

    builder
      .addCase(getVehicleOptions.pending, state => {
        state.vehicleOptionList.vehicleOptionsLoading = true
        state.vehicleOptionList.vehicleOptionsLoaded = false
      })
      .addCase(getVehicleOptions.fulfilled, (state, action) => {
        state.vehicleOptionList.vehicleOptionsLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleOptionList.vehicleOptionsLoaded = true
          state.vehicleOptionList.data = action.payload
        } else {
          state.vehicleOptionList.vehicleOptionsLoaded = false
        }
      })
      .addCase(getVehicleOptions.rejected, state => {
        state.vehicleOptionList.vehicleOptionsLoading = false
      })

    builder
      .addCase(getAllAutoParts.pending, state => {
        state.autoParts.autoPartsLoading = true
        state.autoParts.autoPartsLoaded = false
      })
      .addCase(getAllAutoParts.fulfilled, (state, action) => {
        state.autoParts.autoPartsLoading = false
        if (action.payload && action.payload.length) {
          state.autoParts.autoPartsLoaded = true
          state.autoParts.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title }
          })
        } else {
          state.autoParts.autoPartsLoaded = false
        }
      })
      .addCase(getAllAutoParts.rejected, state => {
        state.autoParts.autoPartsLoading = false
      })

    builder
      .addCase(getAllVehicleAccessories.pending, state => {
        state.vehicleAccessories.vehicleAccessoriesLoading = true
        state.vehicleAccessories.vehicleAccessoriesLoaded = false
      })
      .addCase(getAllVehicleAccessories.fulfilled, (state, action) => {
        state.vehicleAccessories.vehicleAccessoriesLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleAccessories.vehicleAccessoriesLoaded = true
          state.vehicleAccessories.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title }
          })
        } else {
          state.vehicleAccessories.vehicleAccessoriesLoaded = false
        }
      })
      .addCase(getAllVehicleAccessories.rejected, state => {
        state.vehicleAccessories.vehicleAccessoriesLoading = false
      })

    builder
      .addCase(getAllVehicleTypes.pending, state => {
        state.vehicleTypes.vehicleTypesLoading = true
        state.vehicleTypes.vehicleTypesLoaded = false
      })
      .addCase(getAllVehicleTypes.fulfilled, (state, action) => {
        state.vehicleTypes.vehicleTypesLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleTypes.vehicleTypesLoaded = true
          state.vehicleTypes.data = action.payload.map((x: any) => {
            return {
              value: x.id,
              label: x.title,
              hasTrailer: x.hasTrailer,
              hasCargoRoom: x.hasCargoRoom,
            }
          })
        } else {
          state.vehicleTypes.vehicleTypesLoaded = false
        }
      })
      .addCase(getAllVehicleTypes.rejected, state => {
        state.vehicleTypes.vehicleTypesLoading = false
      })

    builder
      .addCase(getAllVehicleUsages.pending, state => {
        state.vehicleUsages.vehicleUsagesLoading = true
        state.vehicleUsages.vehicleUsagesLoaded = false
      })
      .addCase(getAllVehicleUsages.fulfilled, (state, action) => {
        state.vehicleUsages.vehicleUsagesLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleUsages.vehicleUsagesLoaded = true
          state.vehicleUsages.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title, vehicleTypeId: x.vehicleTypeId }
          })
        } else {
          state.vehicleUsages.vehicleUsagesLoaded = false
        }
      })
      .addCase(getAllVehicleUsages.rejected, state => {
        state.vehicleUsages.vehicleUsagesLoading = false
      })

    builder
      .addCase(getAllVehicleBrands.pending, state => {
        state.vehicleBrands.vehicleBrandsLoading = true
        state.vehicleBrands.vehicleBrandsLoaded = false
      })
      .addCase(getAllVehicleBrands.fulfilled, (state, action) => {
        state.vehicleBrands.vehicleBrandsLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleBrands.vehicleBrandsLoaded = true
          state.vehicleBrands.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title, vehicleTypeId: x.vehicleTypeId }
          })
        } else {
          state.vehicleBrands.vehicleBrandsLoaded = false
        }
      })
      .addCase(getAllVehicleBrands.rejected, state => {
        state.vehicleBrands.vehicleBrandsLoading = false
      })

    builder
      .addCase(getAllVehicleTips.pending, state => {
        state.vehicleTips.vehicleTipsLoading = true
        state.vehicleTips.vehicleTipsLoaded = false
      })
      .addCase(getAllVehicleTips.fulfilled, (state, action) => {
        state.vehicleTips.vehicleTipsLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleTips.vehicleTipsLoaded = true
          state.vehicleTips.data = action.payload.map((x: any) => {
            return {
              value: x.id,
              label: x.title,
              vehicleTypeId: x.vehicleTypeId,
              vehicleBrandId: x.vehicleBrandId,
            }
          })
        } else {
          state.vehicleTips.vehicleTipsLoaded = false
        }
      })
      .addCase(getAllVehicleTips.rejected, state => {
        state.vehicleTips.vehicleTipsLoading = false
      })

    builder
      .addCase(getAllVehicleColors.pending, state => {
        state.vehicleColors.vehicleColorsLoading = true
        state.vehicleColors.vehicleColorsLoaded = false
      })
      .addCase(getAllVehicleColors.fulfilled, (state, action) => {
        state.vehicleColors.vehicleColorsLoading = false
        if (action.payload && action.payload.length) {
          state.vehicleColors.vehicleColorsLoaded = true
          state.vehicleColors.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title }
          })
        } else {
          state.vehicleColors.vehicleColorsLoaded = false
        }
      })
      .addCase(getAllVehicleColors.rejected, state => {
        state.vehicleColors.vehicleColorsLoading = false
      })

    builder
      .addCase(getAllStates.pending, state => {
        state.states.statesLoading = true
        state.states.statesLoaded = false
      })
      .addCase(getAllStates.fulfilled, (state, action) => {
        state.states.statesLoading = false
        if (action.payload && action.payload.length) {
          state.states.statesLoaded = true
          state.states.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title }
          })
        } else {
          state.states.statesLoaded = false
        }
      })
      .addCase(getAllStates.rejected, state => {
        state.states.statesLoading = false
      })

    builder
      .addCase(getAllCities.pending, state => {
        state.cities.citiesLoading = true
        state.cities.citiesLoaded = false
      })
      .addCase(getAllCities.fulfilled, (state, action) => {
        state.cities.citiesLoading = false
        if (action.payload && action.payload.length) {
          state.cities.citiesLoaded = true
          state.cities.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.title, stateId: x.stateId }
          })
        } else {
          state.cities.citiesLoaded = false
        }
      })
      .addCase(getAllCities.rejected, state => {
        state.cities.citiesLoading = false
      })

    builder
      .addCase(getEstimatedPriceOfBodyInsurance.pending, state => {
        state.newVisit.coverages.loading = true
      })
      .addCase(getEstimatedPriceOfBodyInsurance.fulfilled, (state, action) => {
        state.newVisit.coverages.loading = false
        state.newVisit.coverages.loaded = true
        state.newVisit.coverages.estimatedPriceOfBodyInsurance = action.payload
      })
      .addCase(getEstimatedPriceOfBodyInsurance.rejected, state => {
        state.newVisit.coverages.loading = false
      })

    builder
      .addCase(GetAllWithVehicleTypes.pending, state => {
        state.cargoRoom.cargoroomLoading = true
        state.cargoRoom.cargoRoomLoaded = false
      })
      .addCase(GetAllWithVehicleTypes.fulfilled, (state, action) => {
        state.cargoRoom.cargoroomLoading = false
        if (action.payload && action.payload.length) {
          state.cargoRoom.cargoRoomLoaded = true
          state.cargoRoom.data = action.payload.map((x: any) => {
            return { value: x.id, label: x.name, vehicleTypeId: x.vehicleTypeId }
          })
        } else {
          state.cargoRoom.cargoRoomLoaded = false
        }
      })
      .addCase(GetAllWithVehicleTypes.rejected, state => {
        state.cargoRoom.cargoroomLoading = false
      })

    builder
      .addCase(GetAllPlateSerial.pending, state => {
        state.freeZone.freeZoneLoading = true
        state.freeZone.freeZoneLoaded = false
      })
      .addCase(GetAllPlateSerial.fulfilled, (state, action) => {
        state.freeZone.freeZoneLoading = false
        if (action.payload && action.payload.length) {
          state.freeZone.freeZoneLoaded = true
          state.freeZone.data = action.payload.map((x: any) => {
            return {
              id: x.id,
              coreId: x.coreId,
              plateRegion: x.plateRegion,
              serial: x.serial,
              order: x.order,
              isEnable: x.isEnable,
              isFreeZone: x.isFreeZone,
            }
          })
        } else {
          state.freeZone.freeZoneLoaded = false
        }
      })
      .addCase(GetAllPlateSerial.rejected, state => {
        state.freeZone.freeZoneLoading = false
      })

    builder
      .addCase(uploadVehicleVisitingPointFiles.pending, state => {
        state.newVisit.vehicleVisitingPoints.loading = true
      })
      .addCase(uploadVehicleVisitingPointFiles.fulfilled, (state, action) => {
        state.newVisit.vehicleVisitingPoints.loading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadVehicleVisitingPointFiles.rejected, state => {
        state.newVisit.vehicleVisitingPoints.loading = false
      })

    builder
      .addCase(uploadDeliberateliesFiles.pending, state => {
        state.newVisit.customerDeliberately.loading = true
      })
      .addCase(uploadDeliberateliesFiles.fulfilled, (state, action) => {
        state.newVisit.customerDeliberately.loading = false
        state.newVisit.storeFileType = 'SERVER'
        state.visitList.queryParams.pageNumber = 1
        if (action.payload != 2) {
          const visitCopy = current(state.newVisit)
          setVisit({ ...visitCopy })
          if (!state.newVisit.isSaved) {
            state.newVisit.lastChangeTime = new Date()
            state.newVisit.isSaved = true
          }
        }
      })
      .addCase(uploadDeliberateliesFiles.rejected, state => {
        state.newVisit.customerDeliberately.loading = false
      })

    builder
      .addCase(uploadVideoFile.pending, state => {
        state.newVisit.vehicleVisitingPoints.videoLoading = true
      })
      .addCase(uploadVideoFile.fulfilled, (state, action) => {
        state.newVisit.vehicleVisitingPoints.videoLoading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadVideoFile.rejected, state => {
        state.newVisit.vehicleVisitingPoints.videoLoading = false
      })

    builder
      .addCase(uploadNotHealthyAutoPartsFiles.pending, state => {
        state.newVisit.notHealthyAutoParts.loading = true
      })
      .addCase(uploadNotHealthyAutoPartsFiles.fulfilled, (state, action) => {
        state.newVisit.notHealthyAutoParts.loading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadNotHealthyAutoPartsFiles.rejected, state => {
        state.newVisit.notHealthyAutoParts.loading = false
      })

    builder
      .addCase(uploadVehicleAccessoriesFiles.pending, state => {
        state.newVisit.vehicleAccessories.loading = true
      })
      .addCase(uploadVehicleAccessoriesFiles.fulfilled, (state, action) => {
        state.newVisit.vehicleAccessories.loading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadVehicleAccessoriesFiles.rejected, state => {
        state.newVisit.vehicleAccessories.loading = false
      })

    //----------------------------------------------------------------

    builder
      .addCase(getUploadLink.pending, state => {
        state.newVisit.uploadLink.loading = true
      })
      .addCase(getUploadLink.fulfilled, (state, action) => {
        state.newVisit.uploadLink.loading = false
        state.newVisit.uploadLink.loaded = true
        if (action.payload.uploadLink) {
          if (action.payload != 'NEW_UPLOAD_LINK') {
            state.newVisit.uploadLink.link = action.payload.uploadLink
            if (action.payload.isNewUploadLink)
              state.newVisit.uploadLink.lastLinkGetTime = String(new Date())
          }
        } else {
          state.newVisit.uploadLink.link = ''
          state.newVisit.uploadLink.lastLinkGetTime = undefined
        }
      })
      .addCase(getUploadLink.rejected, state => {
        state.newVisit.uploadLink.loading = false
      })

    builder
      .addCase(uploadVehicleVisitingPointFilesPodSpace.pending, state => {
        state.newVisit.vehicleVisitingPoints.loading = true
      })
      .addCase(uploadVehicleVisitingPointFilesPodSpace.fulfilled, (state, action) => {
        state.newVisit.vehicleVisitingPoints.loading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadVehicleVisitingPointFilesPodSpace.rejected, state => {
        state.newVisit.vehicleVisitingPoints.loading = false
      })

    builder
      .addCase(uploadDeliberateliesFilesPodSpace.pending, state => {
        state.newVisit.customerDeliberately.loading = true
      })
      .addCase(uploadDeliberateliesFilesPodSpace.fulfilled, (state, action) => {
        state.newVisit.customerDeliberately.loading = false
        state.newVisit.storeFileType = 'POD_SPACE'
        state.visitList.queryParams.pageNumber = 1
        if (action.payload != 2) {
          const visitCopy = current(state.newVisit)
          setVisit({ ...visitCopy })
          if (!state.newVisit.isSaved) {
            state.newVisit.lastChangeTime = new Date()
            state.newVisit.isSaved = true
          }
        }
      })
      .addCase(uploadDeliberateliesFilesPodSpace.rejected, state => {
        state.newVisit.customerDeliberately.loading = false
      })

    builder
      .addCase(uploadVideoFilePodSpace.pending, state => {
        state.newVisit.vehicleVisitingPoints.videoLoading = true
      })
      .addCase(uploadVideoFilePodSpace.fulfilled, (state, action) => {
        state.newVisit.vehicleVisitingPoints.videoLoading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadVideoFilePodSpace.rejected, state => {
        state.newVisit.vehicleVisitingPoints.videoLoading = false
      })

    builder
      .addCase(uploadNotHealthyAutoPartsFilesPodSpace.pending, state => {
        state.newVisit.notHealthyAutoParts.loading = true
      })
      .addCase(uploadNotHealthyAutoPartsFilesPodSpace.fulfilled, (state, action) => {
        state.newVisit.notHealthyAutoParts.loading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadNotHealthyAutoPartsFilesPodSpace.rejected, state => {
        state.newVisit.notHealthyAutoParts.loading = false
      })

    builder
      .addCase(uploadVehicleAccessoriesFilesPodSpace.pending, state => {
        state.newVisit.vehicleAccessories.loading = true
      })
      .addCase(uploadVehicleAccessoriesFilesPodSpace.fulfilled, (state, action) => {
        state.newVisit.vehicleAccessories.loading = false
        const visitCopy = current(state.newVisit)
        setVisit({ ...visitCopy })
        state.newVisit.lastChangeTime = new Date()
        state.newVisit.isSaved = true
      })
      .addCase(uploadVehicleAccessoriesFilesPodSpace.rejected, state => {
        state.newVisit.vehicleAccessories.loading = false
      })

    builder
      .addCase(createVisit.pending, state => {
        state.newVisit.loading = true
      })
      .addCase(createVisit.fulfilled, (state, action) => {
        if (action.payload) {
          removeVisit(Number(state.newVisit.visitLocalId))
          state.newVisit.visitLocalId = Math.random()
          state.newVisit.createTime = new Date()
          state.newVisit.lastChangeTime = undefined
          state.newVisit.isSaved = false
          state.newVisit.hasError = false
          state.newVisit.saveWithoutNet = false
          state.newVisit.storeFileType = 'POD_SPACE'

          state.newVisit.visitId = action.payload.visitId
          state.newVisit.visitStatus = action.payload.visitStatus

          state.newVisit.uploadLink = {
            loading: false,
            loaded: false,
            lastLinkGetTime: undefined,
            link: '',
          }

          state.newVisit.customerInfo = {
            civilRegistryConfirmationLoaded: false,
            validateLegalCustomerSuccess: false,
            validateLegalCustomerData: undefined,
            personType: 0,
            isDeath: false,
            firstName: '',
            lastName: undefined,
            identityCode: '',
            birthDate: undefined,
            gender: 0,
            mobilePhoneNumber: '',
            visitLocationType: 0,
            stateId: undefined,
            cityId: undefined,
            location: undefined,
            nationalityID: 29,
          }
          state.newVisit.customerDeliberately = {
            loading: false,
            nationalCard: undefined,
            nationalCardBack: undefined,
            vehicleDeliberatelyType: 'CARD',
            vehicleCard: undefined,
            vehicleCardBack: undefined,
            vehicleDoc: undefined,
            vehicleCompanyDoc: undefined,
          }
          state.newVisit.carInfo = {
            plate: undefined,
            vehicleTypeId: undefined,
            vehicleBrandId: undefined,
            vehicleTipId: undefined,
            cargoCompartmentId: undefined,
            vehicleColorId: undefined,
            vehicleUsageId: undefined,
            vehicleStatus: undefined,
            numberOfCylinders: undefined,
            yearOfConstruction: undefined,
            vehicleMileage: undefined,
            chassisNumber: '',
            engineNumber: '',
            VIN: '',
          }
          state.newVisit.vehicleVisitingPoints = {
            data: [],
            currentImage: 0,
            mode: 'Image',
            loading: false,
            recordedChunks: [],
            videoRecorded: false,
            videoLoading: false,
            videoUploadProgress: 0,
            videoFileId: undefined,
            videoHashFile: undefined,
            videoHashFileType: undefined,
            videoHashFileExtension: undefined,
            videoHashFileSize: undefined,
            videoStatus: 0,
            videoCancelToken: '',
            skipVideo: false,
          }
          state.newVisit.notHealthyAutoParts = {
            data: [],
            loading: false,
          }
          state.newVisit.vehicleAccessories = {
            data: [],
            loading: false,
          }
          state.newVisit.vehicleOptions = []
          state.newVisit.prices = {
            loading: false,
            loaded: false,
            price: undefined,
            towingValue: undefined,
          }
          state.newVisit.coverages = {
            mainBodyInsuranceCoverageId: undefined,
            additionalBodyInsuranceCoverageId: [],
            loading: false,
            loaded: false,
            estimatedPriceOfBodyInsurance: undefined,
          }
          state.newVisit.description = ''

          state.visitList.queryParams.pageNumber = 1
        } else {
          state.newVisit.hasError = true
        }
        state.newVisit.loading = false
      })
      .addCase(createVisit.rejected, state => {
        state.newVisit.loading = false
      })

    builder
      .addCase(completePendingVisit.pending, state => {
        state.completePendingVisit.loading = true
      })
      .addCase(completePendingVisit.fulfilled, (state, action) => {
        state.visitList.queryParams.pageNumber = 1
        state.completePendingVisit.loading = false
      })
      .addCase(completePendingVisit.rejected, state => {
        state.completePendingVisit.loading = false
      })
  },
})

// Action creators are generated for each case reducer function
export const {
  setFilterModalVisible,
  setFilters,
  setVisitListParams,
  setCustomerInfo,
  setCivilRegistryConfirmationLoaded,
  setCivilRegistryConfirmationIsDeath,
  setCustomerDeliberately,
  removeCustomerDeliberately,
  setCustomerVehicleDeliberatelyType,
  setDeliberatelyFileContent,
  setDeliberatelyUploadProgress,
  successDeliberatelyUploadFile,
  failureDeliberatelyUploadFile,
  setDeliberatelyCancelToken,
  setCarInfo,
  setVehicleOptions,
  setPrice,
  setCoverages,
  setDescription,
  setSaveWithoutNet,
  addVehicleVisitingPoint,
  removeVehicleVisitingPoint,
  setCurrentImage,
  setMode,
  addRecordedChunk,
  clearVehicleVisitingPoints,
  clearVehicleVisitingPointsAndVideo,
  clearVideo,
  setVideoRecorded,
  addNotHealthyAutoPart,
  removeNotHealthyAutoPart,
  addVehicleAccessory,
  removeVehicleAccessory,
  setVehicleVisitingPointFileContent,
  setVehicleVisitingPointUploadProgress,
  successVehicleVisitingPointUploadFile,
  failureVehicleVisitingPointUploadFile,
  setVehicleVisitingPointCancelToken,
  setVideoUploadProgress,
  successVideoUploadFile,
  failureVideoUploadFile,
  setVideoCancelToken,
  setNotHealthyAutoPartFileContent,
  setNotHealthyAutoPartUploadProgress,
  successNotHealthyAutoPartUploadFile,
  failureNotHealthyAutoPartUploadFile,
  setNotHealthyAutoPartCancelToken,
  setVehicleAccessoryFileContent,
  setVehicleAccessoryUploadProgress,
  successVehicleAccessoryUploadFile,
  failureVehicleAccessoryUploadFile,
  setVehicleAccessoryCancelToken,
  setSkipVideo,
  clearNewVisit,
  setNewVisit,
  setStoreFileType,
  saveVisit,
  setDraftVisitId,
  setVisitScrollTop,
  setDispatchId,
  setValidateLegalCustomerSuccess,
  setValidateLegalCustomerData,
} = visitsReducer.actions

export default visitsReducer.reducer
